import { cn } from '@/shared/utils/cn';

/** Native `<select>` styling aligned with compact `Input` (`h-9`). */
export const nativeSelectClass = cn(
  'flex h-9 w-full rounded-sm border border-border-strong bg-surface px-3 text-sm text-fg shadow-sm',
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-primary',
  'disabled:cursor-not-allowed disabled:bg-surface-muted disabled:text-fg-muted',
);
